<template>
  <v-menu eager>
    <template v-slot:activator="{ props }">
      <v-btn v-bind="props" aria-label="Locale Switcher">
        <img :src="utils.getImgUrl(`locales/${$i18n.locale}.png`)" class="locale-image" alt="locale switcher">
      </v-btn>
    </template>
    <v-list>
      <v-list-item
          v-for="(locale, index) in $i18n.availableLocales"
          :key="index"
      >
        <v-list-item-title>
          <v-btn
              v-on:click="changeLocale(locale)"
              :color="$i18n.locale === locale ? 'secondary' : undefined"
              :aria-label="locale"
          >
            <img :src="utils.getImgUrl(`locales/${locale}.png`)" class="locale-image" :alt="locale">
          </v-btn>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>

import { useStore } from 'vuex';

const store = useStore();

const changeLocale = (locale) => {
  store.commit('setLocale', locale);
};
</script>

<style scoped>
.locale-image {
  width: 24px;
  height: 18px;
}
</style>
